import { type CommandHandler } from '@telespot/core';

import { SaveAssetType } from './save-asset-type.command';
import { AssetType, type AssetTypeRepository } from '@telespot/domain';

export type ISaveAssetTypeHandler = CommandHandler<SaveAssetType>;

export class SaveAssetTypeHandler implements ISaveAssetTypeHandler {
  constructor(private readonly assetTypes: AssetTypeRepository) {}

  public async execute(command: SaveAssetType): Promise<string> {
    const { id, name, description, type, version, deviceTypeIds } = command.details;
    const assetType = new AssetType({ id, name, description, type, version, deviceTypeIds });
    return this.assetTypes.save(assetType);
  }
}
